import { Box, SxProps, useTheme } from '@mui/material';
import MuiCheckbox, { CheckboxProps } from '@mui/material/Checkbox';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import { useMemo } from 'react';
import { TextBlock } from 'common/ui/TextBlock';

const BoxCheckedIcon = () => {
  const {
    palette: { primary }
  } = useTheme();

  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.78" y="0.78" width="23.44" height="23.44" rx="5.47" />
      <rect
        x="0.78"
        y="0.78"
        width="23.44"
        height="23.44"
        rx="5.47"
        stroke={primary.main}
        strokeWidth="1.56"
      />
      <path
        d="M18.75 7.81L10.16 16.41L6.25 12.5"
        stroke={primary.main}
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const BoxIcon = () => {
  const {
    palette: { customGrey }
  } = useTheme();

  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.78"
        y="0.78"
        width="23.44"
        height="23.44"
        rx="5.47"
        fill="white"
      />
      <rect
        x="0.78"
        y="0.78"
        width="23.44"
        height="23.44"
        rx="5.47"
        stroke={customGrey.dark}
        strokeWidth="1.56"
      />
    </svg>
  );
};

const container: SxProps = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  my: 1
};

type Props = CheckboxProps & {
  label?: string;
  containerSx?: SxProps;
  isRadioStyle?: boolean;
};

/**
 * @deprecated Use `Checkbox` from `common/form` instead.
 */
export const Checkbox: React.FC<Props> = ({ label, isRadioStyle, ...rest }) => {
  const { icon, checkedIcon } = useMemo(() => {
    if (isRadioStyle) {
      return {
        icon: <RadioButtonUncheckedIcon fontSize="small" />,
        checkedIcon: <RadioButtonCheckedIcon fontSize="small" />
      };
    }

    return {
      icon: <BoxIcon />,
      checkedIcon: <BoxCheckedIcon />
    };
  }, [isRadioStyle]);

  return (
    <Box
      sx={{
        ...container,
        ...rest.containerSx
      }}
    >
      <MuiCheckbox
        {...rest}
        sx={{
          p: 0,
          ...rest.sx
        }}
        icon={icon}
        checkedIcon={checkedIcon}
      />
      {label && <TextBlock variant="field" subtitle={label} />}
    </Box>
  );
};
